export default __webpack_public_path__ + "static/media/icons-20.d315153a.svg";